/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Schedule } from './Schedule';
import {
    ScheduleFromJSON,
    ScheduleFromJSONTyped,
    ScheduleToJSON,
    ScheduleToJSONTyped,
} from './Schedule';

/**
 * 
 * @export
 * @interface UpdateScheduleResponse
 */
export interface UpdateScheduleResponse {
    /**
     * 
     * @type {Schedule}
     * @memberof UpdateScheduleResponse
     */
    data: Schedule;
}

/**
 * Check if a given object implements the UpdateScheduleResponse interface.
 */
export function instanceOfUpdateScheduleResponse(value: object): value is UpdateScheduleResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateScheduleResponseFromJSON(json: any): UpdateScheduleResponse {
    return UpdateScheduleResponseFromJSONTyped(json, false);
}

export function UpdateScheduleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateScheduleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ScheduleFromJSON(json['data']),
    };
}

  export function UpdateScheduleResponseToJSON(json: any): UpdateScheduleResponse {
      return UpdateScheduleResponseToJSONTyped(json, false);
  }

  export function UpdateScheduleResponseToJSONTyped(value?: UpdateScheduleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ScheduleToJSON(value['data']),
    };
}

